import i18n, { use } from 'i18next';
import HttpApi from 'i18next-http-backend';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';

import { LOCALES, Locale, findCDNBaseUrlFromUrl } from '@zooplus/commons-lang';

import packageInfo from '../../package.json';

import { logError } from '@services/sentry-service';
import I18N_RESOURCES from '@utilities/i18n-resources.json';

const version = process.env.RELEASE?.trim() || packageInfo.version.toString();

export const initializeI18n = (locale: Locale) => {
  if (i18n.isInitialized) {
    return i18n;
  }

  use(HttpApi)
    .use(intervalPlural)
    .use(initReactI18next)
    .init({
      compatibilityJSON: 'v3',
      resources: I18N_RESOURCES,
      partialBundledLanguages: true,
      backend: {
        loadPath: (lng: string[], ns: string[]) =>
          `${findCDNBaseUrlFromUrl()}/media/${ns}/${lng[0]}.json`,
        reloadInterval: 3 * 60 * 60 * 1000, //reload every 3 hours
        queryStringParams: { v: version },
      },
      lng: locale,
      load: 'currentOnly',
      ns: [],
      defaultNS: [],
      fallbackLng: 'zu',
      supportedLngs: [...LOCALES, 'zu'],
      debug: false, // set this to true to see your requests being logged
    });

  i18n.on('failedLoading', (lng: string, ns: string, message: string) => {
    logError(new Error(`Could not load ${lng} in ns ${ns}, error message: ${message}`));
  });

  return i18n;
};
